module.exports = __webpack_public_path__ + "static/media/greytriangle.4396e982.svg";